module.exports = __webpack_public_path__ + "11d91a60ca705df6f27a6eabb23013f8.png";